<template lang="pug">
  .btn.btn-info.btn-sm(
    @click="tableToExcel('tblList')"
  )
    i.fas.fa-file-excel.mr-2
    span {{ $t("ui.export_excel") }}
</template>

<script>
export default {
  props: {
    mode: {
      type: String,
      default: ""
    },
    date: {
      type: Object,
      default: ""
    },
    jsonDetails: {
      type: Array,
      default: () => []
    }
  },
  data(){
    return{
      uri :'data:application/vnd.ms-excel;base64,',
      template:'<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
      base64: function(s){ return window.btoa(unescape(encodeURIComponent(s))) },
      format: function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
    }
  },
  methods: {
    tableToExcel(table){
      // var blob = new Blob([Papa.unparse(this.jsonDetails)], { type: 'text/csv;charset=utf-8;' });

      // var link = document.createElement("a");

      // var url = URL.createObjectURL(blob);
      // link.setAttribute("href", url);
      // link.setAttribute("download", 'filename.csv');
      // link.style.visibility = 'hidden';
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);
      if (!table.nodeType) table = document.getElementById(table)
      var worksheetTitle = this.$moment(this.date.startDate).format("DDMMYYYY") + "-" + this.$moment(this.date.endDate).format("DDMMYYYY")
      var ctx = {worksheet: worksheetTitle || 'Worksheet', table: table.innerHTML}
      // window.location.href = this.uri + this.base64(this.format(this.template, ctx))
      var link = document.createElement("a")
      link.download = this.mode + "-" + this.$store.getters.accountID.toUpperCase() + "-" +  worksheetTitle +  ".xls"
      link.href = this.uri + this.base64(this.format(this.template, ctx))
      link.click()
    }
  }
};
</script>